import React from "react";
import { useSoundPath } from "hooks/useSoundPath";

const ActiveItemIdentityMatchesButton = ({
  children,
  color,
  variables,
}) => {

  const playSound = useSoundPath();

  const handleClick = (e) => {
    if (e.currentTarget.classList.contains('active')) {
      e.currentTarget.classList.remove("active");
      playSound("closeSubmenu");
    } else {
      e.currentTarget.classList.add("active");
      playSound("openSubmenu");
    }
  };

  return (
    <button
      className="card-details__craft-item-button card-details__craft-item-button--identity"
      style={{ "--data-color": color }}
      onClick={handleClick}
    >
      <span className="card-details__craft-item-name">{children}</span>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.16667 9.16667H10V13.3333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <rect
          x="9.4335"
          y="6.1"
          width="1.13333"
          height="1.13333"
          fill={color}
          stroke={color}
          strokeWidth="0.3"
        />
      </svg>

      {variables.some((v) => v !== "") && (
        <span className="card-details__craft-item-variables">
          {variables.map(
            (variable, index) =>
              variable !== "" && (
                <span
                  className="card-details__craft-item-variables-item"
                  key={index}
                >
                  {variable}
                </span>
              )
          )}
        </span>
      )}
    </button>
  );
};

export default ActiveItemIdentityMatchesButton;
